import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'AP',
  name: 'Andrea P.',
  role: 'Docente de secundaria — Lima, Perú',
  text: '"Mis alumnos por fin entienden cómo funciona el cuerpo humano y lo conectan con su vida real. Antes yo misma perdía tiempo buscando cómo explicarlo bien. Ahora entro al aula con todo listo."'
}, {
  initials: 'CM',
  name: 'Carlos M.',
  role: 'Profesor de Ciencias de la Salud — Buenos Aires, Argentina',
  text: '"Nunca más llegué a una clase sin saber cómo explicar la homeostasis o la diferencia entre inmunidad innata y adaptativa. El material hace el trabajo pesado por mí."'
}, {
  initials: 'SL',
  name: 'Sofía L.',
  role: 'Docente de bachillerato — Bogotá, Colombia',
  text: '"Las planificaciones me ahorran horas. No improviso nunca más frente a mis alumnos. Y mis estudiantes por fin conectan la biología con su propia vida."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-green-dark border-y border-green-emerald/20" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4" data-id="element-281">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-282">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-cream border border-green-emerald/15 p-6 rounded-2xl relative shadow-sm" data-id="element-283">
              <div className="flex gap-1 text-green-emerald mb-4" data-id="element-284">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-285" />)}
              </div>
              <p className="text-ink-muted italic mb-6 text-sm leading-relaxed" data-id="element-286">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-287">
                <div className="w-10 h-10 rounded-full bg-green-veryLight border border-green-emerald flex items-center justify-center text-green-emerald font-bold" data-id="element-288">
                  {t.initials}
                </div>
                <div data-id="element-289">
                  <div className="font-bold text-ink text-sm" data-id="element-290">{t.name}</div>
                  <div className="text-xs text-ink-muted" data-id="element-291">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}